import { FunctionComponent, useEffect, useState } from 'react';
import { Alert, Button, Card, Flex, Form, FormProps } from 'antd';
import { useTranslation } from 'react-i18next';

// components
import { onGetMangerDetails, onSubmitMangerDetails } from '../services/documentsService';
import NotificationService from 'core/services/notification';
import LoadingComponent from 'components/loadingComponent/loadingComponent';
import FormElement from 'components/formElement/formElement';

type FieldType = {
	authorized_signatory_name: string;
};

const SignatoryPersonComponent: FunctionComponent = () => {
	const { t } = useTranslation();
	const [nameForm] = Form.useForm();

	const [name, setName] = useState<string>('');
	const nameFormWatch = Form.useWatch('authorized_signatory_name', nameForm);

	const [isLoading, setIsLoading] = useState(true);
	const [isSubmiting, setIsSubmitting] = useState(false);

	useEffect(() => {
		getManagerDetails();
	}, []);

	const getManagerDetails = async () => {
		try {
			setIsLoading(true);

			const response = await onGetMangerDetails();
			nameForm.setFieldValue('authorized_signatory_name', response.authorized_signatory_name);
			setName(response.authorized_signatory_name);

			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			NotificationService.error(t('COMMON.ERROR'), t('COMMON.FETCH_ERROR'));
		}
	};

	const onFinish: FormProps<FieldType>['onFinish'] = async (values) => {
		try {
			setIsSubmitting(true);

			await onSubmitMangerDetails(values.authorized_signatory_name);
			setName(values.authorized_signatory_name);

			setIsSubmitting(false);
			NotificationService.success(t('COMMON.SUCCESS'), t('DOCUMENTS.AUTHORIZED_SIGNATORY_NAME_UPDATED'));
		} catch (error) {
			setIsSubmitting(false);
			NotificationService.error(t('COMMON.ERROR'), t('COMMON.SUBMIT_ERROR'));
		}
	};

	return (
		<Card>
			<Alert message={t('DOCUMENTS.AUTHORIZED_SIGNATORY_PERSON_DESC')} type="info" showIcon style={{ fontWeight: 500, fontSize: 15 }} />

			{isLoading ? (
				<LoadingComponent />
			) : (
				<Form form={nameForm} onFinish={onFinish} className="mt-4">
					<FormElement
						name="authorized_signatory_name"
						type="text"
						fullWidth
						label={t('DOCUMENTS.AUTHORIZED_SIGNATORY_PERSON_NAME')}
						rules={[{ required: true, message: t('COMMON.FIELD_REQUIRED') }]}
					/>

					<Flex justify="flex-end">
						<Button type="primary" htmlType="submit" size="large" loading={isSubmiting} disabled={isSubmiting || nameFormWatch === name}>
							{t('COMMON.SUBMIT')}
						</Button>
					</Flex>
				</Form>
			)}
		</Card>
	);
};

export default SignatoryPersonComponent;
